import {Label, Link} from '@primer/react'
import {useState} from 'react'

import {useIssuesIndexSemanticSearchToggleFeaturePreview} from '../../hooks/use-issues-index-semantic-search-toggle-feature-preview'
import styles from './SemanticSearchFeaturePreview.module.css'

export function SemanticSearchFeaturePreview() {
  const {isAvailable, isEnabled, isLoading, feedbackLink, toggle} = useIssuesIndexSemanticSearchToggleFeaturePreview()
  const [hasError, setHasError] = useState<boolean>(false)

  // Don't show anything if feature flag is disabled/feature preview is not available
  if (!isAvailable || isLoading) {
    return null
  }

  const handleToggle = async (e: React.MouseEvent) => {
    e.preventDefault()
    setHasError(false)
    try {
      await toggle()
    } catch {
      setHasError(true)
    }
  }

  if (isEnabled) {
    return (
      <div className={styles.previewWrapper}>
        <div className={styles.previewContainer}>
          <div className={styles.previewBadge}>
            <Label variant="success">Private preview</Label>
          </div>
          <div className={styles.previewLinks}>
            <Link href={feedbackLink} target="_blank" rel="noopener noreferrer">
              Semantic search feedback
            </Link>
            <Link as="button" onClick={handleToggle}>
              Opt out
            </Link>
          </div>
        </div>
        {hasError && (
          <div role="alert" aria-live="polite" className={styles.errorMessage}>
            There was an error opting out of the semantic search feature preview. Please try again later.
          </div>
        )}
      </div>
    )
  } else {
    return (
      <div className={styles.previewWrapper}>
        <div className={styles.previewContainer}>
          <div className={styles.previewLinks}>
            <Link as="button" onClick={handleToggle}>
              Try the new semantic search
            </Link>
          </div>
        </div>
        {hasError && (
          <div role="alert" aria-live="polite" className={styles.errorMessage}>
            There was an error opting in to the semantic search feature preview. Please try again later.
          </div>
        )}
      </div>
    )
  }
}

try{ SemanticSearchFeaturePreview.displayName ||= 'SemanticSearchFeaturePreview' } catch {}